<template>
  <div class="version-wrap">
    <div class="title">各版本区别</div>
    <div class="content my-type-info my-font-xs">
      <!-- =======================列名======================= -->
      <div class="my-flex my-col-top">
        <!-- -----第一个列 功能项 -->
        <div class="my-flex-1 colItem my-text-left" style="min-width: 60px;">
          <div class="my-font-sm">功能项</div>
        </div>
        <!-- -----第二个列 免费版 -->
        <div class="my-flex-1 colItem my-text-center" v-if="hasFreeVersion">
          <div class="my-font-sm" style="font-weight: bold;color: #666;">免费版</div>
        </div>
        <!-- -----其他列 遍历版本 -->
        <div class="my-flex-1 colItem my-text-center" v-for="version in versions" :key="version.code">
          <div class="my-font-sm" style="font-weight: bold;color: #666;">{{version.name}}</div>
          <div class="my-type-info">
            <span class="my-type-error my-font-bold">￥{{ version.priceYear }}</span>/年
          </div>
          <div class="my-type-info" v-if="version.priceForever">
            <span class="my-type-error my-font-bold">￥{{ version.priceForever }}</span>/长期
          </div>
        </div>
      </div>
      <!-- =======================购买======================= -->
      <div class="my-flex my-col-top" v-if="showBuy">
        <!-- -----第一个列 功能项 -->
        <div class="my-flex-1 colItem my-text-left" style="min-width: 60px;"></div>
        <!-- -----第二个列 免费版 -->
        <div class="my-flex-1 colItem my-text-center" v-if="hasFreeVersion"></div>
        <!-- -----其他列 遍历版本 -->
        <div class="my-flex-1 colItem my-text-center" v-for="version in versions" :key="version.code">
          <div>
            <div
              @click="$emit('buyVersion',version.code)"
              class="btn2"
              :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`}"
            >立即购买</div>
          </div>
        </div>
      </div>
      <!-- =======================行======================= -->

      <div v-for="(cate,indexCate) in dataList" :key="indexCate">
        <!-- 分组 -->
        <div v-if="dataList.length>1" class="my-m-t-5 my-m-b-5" style="color:#666;">
          <span class="my-p-l-5">{{ cate.name }}</span>
          <div class="title-bar" :style="{background:`rgba(255,248,239,0.25)`}"></div>
        </div>
        <div class="my-flex rowItem" v-for="(item,indexItem) in cate.items" :key="`item_${indexItem}`">
          <!-- -----第一个列 功能项 -->
          <div class="my-flex-1 cellItem my-text-left" style="min-width: 60px;">
            {{item.name}}
            <!-- <i class="el-icon-warning-outline" v-if="item.tips" alt="item.tips" /> -->
          </div>
          <!-- -----其他列 遍历版本 -->
          <div
            v-for="(cell,indexCell) in item.versions"
            :key="`cell_${indexCell}`"
            class="my-flex-1 cellItem my-text-center"
            v-show="cell.version!='Legacy'||hasLegacy"
          >
            <!-- 对号 -->
            <i v-if="cell.value == 'true'" class="el-icon-success my-type-success" style="font-size: 18px;" />
            <!-- 叉号 -->
            <i v-else-if="cell.value == 'false'" class="el-icon-close my-type-error" style="font-size: 18px;" />
            <!-- 选购 -->
            <span v-else-if="cell.value == ''" :style="{color:cell.color||'#c4c6c9'}">选购</span>
            <!-- 直接显示 -->
            <span v-else :style="{color:cell.color}">{{cell.value}}</span>
            <!-- {{item.name}} -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    versions: {
      type: Array,
      default: () => []
    },
    hasFreeVersion: {
      type: Boolean,
      default: false
    },
    hasLegacy: {
      type: Boolean,
      default: false
    },
    showBuy: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.version-wrap {
  .title {
    font-size: 14px;
    color: #472e09;
    padding: 10px 0 30px 15px;
    background: linear-gradient(to right, #ffe9c9, #fec869);
    border-radius: 20px 20px 0 0;
  }

  .content {
    margin-top: -20px;
    background: #fff;
    border-radius: 20px 20px 0 0;
    padding: 15px;
    font-size: 12px;
    border: 1px solid #ffe9c9;

    .rowItem {
      &:hover {
        background: #faf5ee;
      }
    }
    // .rowItem + .rowItem {
    //   background: #fbf9f8;
    // }

    .colItem {
      padding: 10px;
    }
    .cellItem {
      padding: 10px;
    }
  }

  .title-bar {
    width: 100% !important;
    height: 15px !important;
    margin-top: -10px !important;
    margin-bottom: 5px !important;
  }
}

@media screen and (max-width: 576px) {
  .version-wrap {
    .content {
      padding: 15px 5px;
      .colItem {
        padding: 5px 2px;
      }
      .cellItem {
        padding: 5px 2px;
      }
    }
  }
}
</style>